<template>
  <div id="DebtorReport">
    <loading v-if="loadingRender"></loading>
    <panel
      Title="گزارش برداشت از حساب"
      Des="از طریق این فرم می‌توانید لیست برداشت‌ها از حساب‌های خود را مشاهده نمایید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row">
      <div class="card p-3 m-3 w-100" id="Date">
        <div class="row">
          <span class="alert alert-dark text-center text-dark w-100 p-2 m-2"
            >لطفا حساب مورد نظر خودرا انتخاب کرده و سپس گزینه
            <span class="text-success">جستجو</span> را بزنید
          </span>
        </div>
        <div class="DebtorReport-inputs">
          <div class="DebtorReport-field DebtorReport-account">
            <small>انتخاب حساب</small>
            <select
              v-if="IsLoad"
              name="cmbTaahodat"
              id="cmbTaahodat"
              class="form-control Pointer"
              v-model="Resultcmb"
            >
              <option v-if="this.IsLoad == false" value="-2">
                || در حال بارگذاری ، منتظر بمانید ... ||
              </option>
              <option selected value="-1">-- انتخاب حساب --</option>
              <option
                v-for="item in this.ListModel"
                :key="item.id"
                :value="item.vCode"
              >
                <span>{{ item.vcodeDesNo }} </span
                ><span>{{ item.nameFamily }} </span>
              </option>
            </select>
          </div>
          <div class="DebtorReport-field DebtorReport-date-field">
            <small>از تاریخ</small>
            <date-picker
              :auto-submit="true"
              :max="TarikhTa"
              color="rgb(94 163 30)"
              v-model="TarikhAz"
            ></date-picker>
            <input
              type="text"
              tabindex="-1"
              class="d-none InputText"
              style="direction: ltr"
            />
          </div>
          <div class="DebtorReport-field DebtorReport-date-field">
            <small>تا تاریخ</small>
            <date-picker
              :auto-submit="true"
              :min="TarikhAz"
              color="rgb(94 163 30)"
              v-model="TarikhTa"
            ></date-picker>
            <input
              type="text"
              tabindex="-1"
              class="d-none InputText"
              style="direction: ltr"
            />
          </div>
        </div>
        <div class="row DebtorReport-actions">
          <div v-if="rows.length > 0" class="col-md-2 col-12 mt-3">
            <input
              type="button"
              name=""
              value="لغو همه"
              class="btn btn-danger mt-2 w-100"
              @click="
                DeleteAllEnteghal(rows);
                $ResetTimer();
              "
              title="لغو همه درخواست‌های تایید نشده"
            />
          </div>
          <div
            class="col-12 mt-3"
            :class="rows.length > 0 ? 'col-md-8' : 'col-md-10'"
          ></div>
          <div class="col-md-2 col-12 mt-3">
            <input
              type="button"
              name=""
              value="جستجو"
              class="btn btn-success mt-2 w-100"
              @click="
                GetDebtorReport();
                $ResetTimer();
              "
            />
          </div>
        </div>
      </div>
    </div>
    <vue-bootstrap4-table
      :rows="rows"
      :columns="columns"
      :config="config"
      :classes="classes"
    >
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>
      <template slot="empty-results">
        <p class="text-right">اطلاعاتی یافت نشد</p>
      </template>
      <template slot="shomareSanad" slot-scope="props">
        <small
          v-if="
            (props.cell_value == 0 || props.cell_value === 'تاييد نشده') &&
            props.row.inProgress == false
          "
          class=""
        >
          <div
            class="btn Pointer btn-outline-danger"
            @click="DeleteEnteghal(props)"
          >
            لغــو درخواست
          </div>
        </small>
        <small v-else-if="props.cell_value > 0" class="text-success">
          <i class="fas fa-check-circle"></i>
          تایید شده
        </small>
        <small v-else class="text-warning">
          <i class="fas fa-times-circle"></i>
          درحال بررسی
        </small>
      </template>

      <template slot="tarixSanad" slot-scope="props">
        {{ props.row.zamanInsert }} {{ props.row.tarixSanad }}
      </template>
      <template slot="cardNo" slot-scope="props">
        {{ props.row.cardNo }}
        <!-- {{ props.row.cardNo ==null?"IR "+props.row.shebaNo:props.row.cardNo }} -->
      </template>
    </vue-bootstrap4-table>
  </div>
</template>
<script>
import Panel from "../Tools/NetPa/Panel.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import loading from "../Tools/NetPa/Loading.vue";
export default {
  data() {
    return {
      DataAxios_DeleteEnteghal: {
        ArryfildValue: "",
        Method: "Post",
        Action: "Gardesh_Taahodat/RemoveBardasht",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListEnteghal",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      Resultcmb: null,
      IsLoad: false,
      ListModel: null,
      vCode: null,
      TarikhAz: "",
      TarikhTa: "",
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },
        {
          label: "شماره حساب",
          name: "fromVcode",
        },
        {
          label: "نام صاحب حساب",
          name: "fromSahebHesab",
        },
        {
          label: "مبلغ انتقال",
          name: "mabEnteghal",
        },
        {
          label: "تاریخ درخواست",
          name: "tarixSanad",
          sort: true,
        },
        {
          label: "شماره شبا ",
          name: "shebaNo",
        },
        {
          label: "شماره کارت ",
          name: "cardNo",
          visibility: this.$session.get("CustCode") == 866 ? false : true,
        },
        {
          label: "کدرهگیری",
          name: "codeRahgiri",
        },
        {
          label: "وضعیت",
          name: "shomareSanad",
        },
        {
          label: "IsDeleted",
          name: "isDeleted",
          visibility: false,
        },
        {
          label: "توضیحات",
          name: "rejectMessage",
          visibility: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      loadingRender: false,
      ListModelSahebHesab: null,
    };
  },
  components: {
    Panel,
    VueBootstrap4Table,
    loading,
  },
  mounted() {
    const formData = new FormData();
    let info;
    formData.append(
      "wwwtblAzaId",
      this.$session.get("UserInfoNetPa").wwwtblAzaId,
    );
    formData.append("wwwtblSarfaslTypeId", 2);
    this.DataAxios_cmbTaahodat.ArryfildValue = formData;
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true;
        this.ListModel = data;
        this.Resultcmb = data[0].vCode;
      })
      .finally(() => {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblSarfaslTypeId", 2);
        this.DataAxios_SahebHesab.ArryfildValue = formData;
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true;
            this.ListModelSahebHesab = data;
            for (
              let index = 0;
              index < this.ListModelSahebHesab.length;
              index++
            ) {
              if (this.ListModelSahebHesab[index].mande > 0) {
                info = this.ListModelSahebHesab[index];
                this.ListModel.push(info);
              }
            }
          }
        });
      });
  },
  methods: {
    Deleteall(data) {
      var flag = 0;
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (
          (element.shomareSanad == 0 ||
            element.shomareSanad === "تاييد نشده") &&
          element.inProgress == false
        ) {
          flag = 1;
          this.loadingRender = true;
          const formData = new FormData();
          formData.append("wwwtblEnteghal", element.id);
          formData.append("VCode", element.fromVcode);
          formData.append("Mablagh", element.mabEnteghal.replace(/,/g, ""));
          formData.append("wwwtblGardeshId", element.wwwtblGardeshId);
          this.DataAxios_DeleteEnteghal.ArryfildValue = formData;

          this.$PostFormData(this.DataAxios_DeleteEnteghal).then(() => {
            this.$mySweetDefaultTost(
              "حذف موفق",
              " حذف همه درخواست برداشت‌ها از حساب مورد نظر با موفقیت انجام شد",
              "success",
              4000,
            );

            this.loadingRender = false;
            this.GetDebtorReport();
          });
        }
      }
      if (flag == 0) {
        this.$mySweetDefaultTost(
          "خطا",
          "هیچ ردیفی برای لغو وجود ندارد ",
          "warning",
          2000,
        );
        return;
      }
    },
    GetDebtorReport() {
      if (this.Resultcmb == null || this.Resultcmb == -1) {
        this.$mySweetDefaultTost(
          "خطا",
          "لطفا یک حساب انتخاب کنید",
          "warning",
          2000,
        );
        this.rows = [];
      } else {
        this.loadingRender = true;
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("AzTarix", this.TarikhAz);
        formData.append("TaTarix", this.TarikhTa);
        formData.append("Vcode", this.Resultcmb);
        this.DataAxiosRow.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosRow).then((data) => {
          //console.log("😎 ~ this.$PostFormData ~ data:", data)
          if (data.length) {
            let info;
            let list = [];
            if (data.length > 10) {
              this.config.pagination = true;
            } else {
              this.config.pagination = false;
            }
            for (let index = 0; index < data.length; index++) {
              info = data[index];
              info["row"] = index + 1;
              list.push(info);
            }
            this.rows = this.$FormatMablaghGrid(list);
            this.loadingRender = false;
          } else {
            this.$mySweetDefaultTost(
              "عدم وجود اطلاعات",
              "درخواست انتقال یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
              "warning",
              2000,
            );
            this.config.pagination = false;
            this.rows = [];
            this.loadingRender = false;
          }
        });
      }
    },
    DeleteEnteghal(item) {
      this.$SweetQustion(
        "حذف درخواست برداشت",
        "آیا از حذف درخواست برداشت خود اطمینان دارید؟",
        "error",
        "تایید",
        "انصراف",
        item,
        this.Delete,
        this.CancelDelete,
      );

      // console.log(item);
    },
    DeleteAllEnteghal(item) {
      this.$SweetQustion(
        "حذف درخواست‌های برداشت",
        "آیا از حذف درخواست برداشت‌های تایید نشده خود اطمینان دارید؟",
        "error",
        "تایید",
        "انصراف",
        item,
        this.Deleteall,
        this.CancelDelete,
      );

      // console.log(item);
    },
    Delete(node) {
      this.loadingRender = true;
      const formData = new FormData();
      formData.append("wwwtblEnteghal", node.row.id);
      formData.append("VCode", node.row.fromVcode);
      formData.append("Mablagh", node.row.mabEnteghal.replace(/,/g, ""));
      formData.append("wwwtblGardeshId", node.row.wwwtblGardeshId);
      this.DataAxios_DeleteEnteghal.ArryfildValue = formData;

      this.$PostFormData(this.DataAxios_DeleteEnteghal).then(() => {
        this.$mySweetDefaultTost(
          "حذف موفق",
          " حذف درخواست برداشت از حساب مورد نظر با موفقیت انجام شد",
          "success",
          4000,
        );

        this.loadingRender = false;
        this.GetDebtorReport();
      });
    },
    CancelDelete() {},
  },
};
</script>
<style scoped>
.DebtorReport-inputs {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 1rem;
  width: 100%;
  margin-top: 0.5rem;
}
.DebtorReport-field {
  text-align: right;
  min-width: 0;
}
.DebtorReport-account {
  flex: 1 1 34%;
}
.DebtorReport-date-field {
  flex: 1 1 33%;
}
.DebtorReport-date-field >>> .vpd-main {
  display: block;
  width: 100%;
}
.DebtorReport-date-field >>> .vpd-input-group {
  width: 100%;
}
.DebtorReport-date-field >>> .vpd-input-group input {
  width: 100%;
}
@media (max-width: 767px) {
  .DebtorReport-inputs {
    flex-wrap: wrap;
  }
  .DebtorReport-account,
  .DebtorReport-date-field {
    flex: 1 1 100%;
  }
}
</style>
